import {TextField} from '@wandb/weave/components/Form/TextField';
import React, {useCallback} from 'react';

import {DD_PRIVACY_ALLOW} from '../../../../../util/datadog/privacy';
import {getTitleFromConfig} from '../../../../PanelMediaBrowser/utils/getTitleFromConfig';
import {
  usePanelMediaChartTitle,
  useShouldShowMediaChartTitleResetAtLevel,
} from '../../hooks';
import {useUpdateChartTitle} from '../../hooks/useUpdateChartTitle';
import {SettingTitle} from '../common/SettingTitle';
import {useMediaSettingsContext} from '../contexts/MediaSettingsContextProvider';
export const ChartTitle = () => {
  const {config, updateConfig, unsetConfigField, settingsLevel, panelRef} =
    useMediaSettingsContext();
  const chartTitle = usePanelMediaChartTitle(panelRef);
  const isChartTitleSet = useShouldShowMediaChartTitleResetAtLevel(
    settingsLevel,
    panelRef
  );

  const {chartTitle: _, ...configWithoutChartTitle} = config;
  const defaultChartTitle = getTitleFromConfig(configWithoutChartTitle);

  const unsetConfigFieldCallback = useCallback(() => {
    unsetConfigField('chartTitle');
  }, [unsetConfigField]);
  const updateConfigCallback = useCallback(
    (title: string) => {
      updateConfig({chartTitle: title});
    },
    [updateConfig]
  );

  const {value, onChange, resetValue} = useUpdateChartTitle({
    defaultChartTitle,
    chartTitle,
    unsetConfigField: unsetConfigFieldCallback,
    updateConfig: updateConfigCallback,
  });

  return (
    <div className="flex flex-col">
      <SettingTitle
        title="Panel title"
        configField="chartTitle"
        isDirty={isChartTitleSet}
        unsetConfigField={resetValue}
      />
      <div data-dd-privacy={DD_PRIVACY_ALLOW}>
        <TextField
          dataTest="media-chart-title-input"
          value={value}
          onChange={onChange}
        />
      </div>
    </div>
  );
};
